module.exports = __webpack_public_path__ + "img/feed.f1d772c1.svg";